import React, { useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen((v) => !v);

  const menuItems = [
    { name: "Início", href: "#home" },
    { name: "Portfólio", href: "#portfolio" },
    { name: "Processo", href: "#processo" },
    { name: "Sobre", href: "#sobre" },
    { name: "Contato", href: "#contato" },
  ];

  const scrollToContato = () => {
    const el = document.getElementById("contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100">
      {/* ✅ TROCA DO container: evita width fixa maior que a viewport no mobile */}
      <div className="mx-auto w-full max-w-7xl px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo Forttana */}
          <div className="flex items-center gap-3 min-w-0">
            <div className="relative flex-shrink-0">
              <img
                src="/assets/images/logo-forttana.png"
                alt="Forttana Eventos"
                width="50"
                height="50"
                className="object-contain"
                draggable={false}
              />
            </div>

            <div className="min-w-0">
              <div className="text-2xl font-black tracking-wider leading-none">
                <span className="text-gray-900 font-empresa">FORTTANA</span>
              </div>
              <div className="text-sm font-medium text-gray-600 -mt-1 tracking-[0.3em] font-empresa whitespace-nowrap">
                EVENTOS
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-gray-700 hover:text-[#FF1616] transition-colors duration-200 font-medium tracking-wide"
              >
                {item.name}
              </a>
            ))}

            <Button
              className="bg-[#FF1616] hover:bg-red-700 text-white px-6 font-bold tracking-wide"
              onClick={scrollToContato}
              type="button"
            >
              ORÇAMENTO GRÁTIS
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden p-2 text-gray-700 hover:text-[#FF1616] transition-colors"
            type="button"
            aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-4 pt-4">
              {menuItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-700 hover:text-[#FF1616] transition-colors duration-200 font-medium py-2 tracking-wide"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}

              <Button
                className="bg-[#FF1616] hover:bg-red-700 text-white w-full mt-4 font-bold tracking-wide"
                onClick={scrollToContato}
                type="button"
              >
                ORÇAMENTO GRÁTIS
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
